module.exports = __webpack_public_path__ + "static/media/Compensation.7d5c9ece.svg";